/* eslint-disable import/no-mutable-exports */
/* eslint-disable prefer-const */

let config = {
  Auth: {
    mandatorySignIn: true,
    region: process.env.VUE_APP_AMPLIFY_COGNITO_REGION,
    get identityPoolId() {
      return localStorage.getItem('identityId') || '';
    },
    set identityPoolId(value) {
      localStorage.setItem('identityId', value);
    },
    get userPoolId() {
      return (localStorage.getItem('userPoolId') || process.env.VUE_APP_AMPLIFY_COGNITO_USER_POOL_ID);
    },
    get userPoolWebClientId() {
      return (localStorage.getItem('webClientId') || process.env.VUE_APP_AMPLIFY_COGNITO_APP_CLIENT_ID);
    },
    set userPoolId(value) {
      localStorage.setItem('userPoolId', value);
    },
    set userPoolWebClientId(value) {
      localStorage.setItem('webClientId', value);
    },
    get endpoint() {
      return `${process.env.VUE_APP_BE_BASE_URL}/iam/auth`;
    },
  },
  Storage: {
    AWSS3: {
      region: process.env.VUE_APP_AMPLIFY_COGNITO_REGION,
      get bucket() {
        return (localStorage.getItem('userPoolId')?.replace(/_/g, '').toLowerCase() || process.env.VUE_APP_AMPLIFY_BUCKET_NAME);
      },
      set bucket(value) {
        localStorage.setItem('bucketName', value);
      },
    },
  },
};
export default config;
